export const DEFAULT_CHANGE_PASSWORD_WITHOUT_OLD_FORM = 'CHANGE_PASSWORD_WITHOUT_OLD';
